import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import { NegociosService, PosicionService, EntregaService, PreciosService } from '@services/index';

import {
  CuentaAutocompleteComponent,
  ColaboradorAutocompleteComponent,
  AcopioAutocompleteComponent
} from '@common/autocomplete';

import * as moment from 'moment';
import { MonedaService } from '@services/moneda-service';

@Component({
  selector: 'filters-precios-dialog-component',
  templateUrl: './filters-precios-dialog.component.html',
  styleUrls: ['./filters-precios-dialog.component.scss']
})
export class FiltersPreciosDialogComponent implements OnInit, AfterViewInit {

  public title: string;
  public column: string;
  private column2: string;
  public filters = {};

  private entregaOptions = [];
  private negocioOptions = [];
  private monedaOptions = [];
  private mercadoOptions = [];

  private errors;

  // Columnas que no comparten formato de filtro en el template
  private regularColumns = ['mercado', 'fecha', 'negocio', 'entrega', 'moneda', 'responsable', 'validador', 'cotización', 'publicación'];

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;

  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;

  constructor(public dialogRef: MdDialogRef<FiltersPreciosDialogComponent>, private negociosService: NegociosService,
    private monedaService: MonedaService, private posicionService: PosicionService, private entregaService: EntregaService, preciosService: PreciosService) {
    monedaService.Options.subscribe(newValue => {
      this.monedaOptions = newValue;
    });
    entregaService.PosicionOptions.subscribe(newValue => {
      this.entregaOptions = newValue;
    });
    preciosService.getMercadosPizarra().subscribe(newValue => {
      this.mercadoOptions = newValue;
    });
  }

  ngOnInit() {
    this.posicionService.loadOptions();

    // Copiar datos e inicializar modelos
    if (this.column === 'fecha' || this.column === 'publicación') {
      if (!this.filters['fecha']) {
        this.filters['fecha'] = {
          startDate: moment().subtract(15, 'days').toDate(),
          endDate: moment().toDate()
        };
      } else {
        this.filters['fecha'] = {
          startDate: moment(this.filters['fecha'].startDate).toDate(),
          endDate: moment(this.filters['fecha'].endDate).toDate()
        };
      }
    } else if (this.column === 'cotización') {
      if (!this.filters[this.column]) {
        this.filters[this.column] = {
          startDate: moment().subtract(15, 'days').toDate(),
          endDate: moment().toDate()
        };
      } else {
        this.filters[this.column] = {
          startDate: moment(this.filters[this.column].startDate).toDate(),
          endDate: moment(this.filters[this.column].endDate).toDate()
        };
      }
    } else if (this.column !== 'responsable' && this.column !== 'validador') {
      if (!this.filters[this.column]) {
        this.filters[this.column] = { model1: null, model2: null };
      }
    }

    this.negocioOptions = this.negociosService.getNegocioSelectOptions().slice(0,3);    // sacamos basis por ahora

    this.column2 = this.regularColumns.indexOf(this.column) < 0 ? 'producto-comun' : null;
  }

  ngAfterViewInit() {
    if (this.column === 'responsable') {
      this.colaboradorAutocompleteComponent.selectedColaboradores = this.filters['responsable'] ? this.filters['responsable'].slice() : [];
    } else if (this.column === 'validador') {
      this.colaboradorAutocompleteComponent.selectedColaboradores = this.filters['validador'] ? this.filters['validador'].slice() : [];
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  showStartDatePicker() {
    this.startDatePicker.open();
  }

  showEndDatePicker() {
    this.endDatePicker.open();
  }

  selectedStartDate(e) {
    if (e > this.filters[this.column].endDate) {
      this.filters[this.column].endDate = e;
    }
  }

  selectedEndDate(e) {
    if (e < this.filters[this.column].startDate) {
      this.filters[this.column].startDate = e;
    }
  }

  onSubmit() {
    this.errors = false;

    if (this.errors) {
      return;
    }

    // Opción 'Todos' en selects
    if ((['negocio', 'entrega', 'moneda', 'mercado'].indexOf(this.column) >= 0) &&
        (this.filters[this.column].model1 === ''))
    {
      let tmp = Object.assign({}, {...this.filters});
      delete tmp[this.column];
      this.dialogRef.close({
        column: this.column,
        filters: tmp
      });
      return;
    }

    if (this.column === 'responsable') {
      this.filters['responsable'] = this.colaboradorAutocompleteComponent.selectedColaboradores;
    } else if (this.column === 'validador') {
      this.filters['validador'] = this.colaboradorAutocompleteComponent.selectedColaboradores;
    }

    // Value for display in chips
    if (this.column === 'negocio') {
      this.filters['negocio'].model1Value = this.negocioOptions.find(e => e.value === this.filters['negocio'].model1).label;
    } else if (this.column === 'entrega') {
      this.filters['entrega'].model1Value = this.filters['entrega'].model1.Entrega || this.filters['entrega'].model1.Posicion;
    } else if (this.column === 'moneda') {
      this.filters['moneda'].model1Value = this.monedaOptions.find(e => e.ID === this.filters['moneda'].model1).Simbolo;
    } else if (this.column === 'mercado') {
      this.filters['mercado'].model1Value = this.mercadoOptions.find(e => e.Id === this.filters['mercado'].model1).Mercado;
    }

    this.dialogRef.close({
      column: this.column,
      filters: this.filters
    });
  }

  getInputPlaceholder() {
    let label = '';
    if (this.column === 'responsable') {
      label = 'Responsables';
    } else if (this.column === 'validador') {
      label = 'Validadores';
    }
    return 'Elige uno o varios ' + label;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/filters-precios-dialog.component.ts